import './publicpath';
import 'core-js/stable';
import Vue from 'vue';
import Router from 'vue-router';
import VueClipboard from 'vue-clipboard2';
import VueHtmlToPaper from 'vue-html-to-paper';
import VueResource from 'vue-resource';
import CoreuiVue from '@coreui/vue/src';
import App from './App';
import store from './store';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fad } from '@fortawesome/pro-duotone-svg-icons';

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(VueHtmlToPaper);
Vue.use(VueResource);
Vue.use(CoreuiVue);
Vue.use(Router);

library.add(fas, far, fal, fad);

Vue.component(FontAwesomeIcon.name, FontAwesomeIcon);

window.route = process.env.NODE_ENV === 'production' ? 'https://' + window.location.host : '';

const router = new Router({
    base: '/user_guide',
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open active',
    scrollBehavior: () => ({y: 0}),
    routes: [
        {
            path: '/',
            redirect: '/home',
            name: 'Home',
            meta: {
                label: 'Home'
            },
            component: () => import('@/containers/TheContainer'),
            children: [
                {
                    path: '/home',
                    name: 'User Guides',
                    component: () => import('@/views/Home')
                },
                {
                    path: '/user_guide',
                    redirect: '/user_guide/home',
                    name: 'User Guides',
                    component: () => import('@/containers/TheUserGuidesContainer'),
                    children: [
                        {
                            path: '/:guideID/home',
                            name: 'Guide',
                            component: () => import('@/views/guides/Guide'),
                        },
                        {
                            path: '/:guideID',
                            redirect: '/:guideID/home',
                            name: 'Guide',
                            component: () => import('@/containers/TheUserGuideContainer'),
                            children: [
                                {
                                    path: '/:guideID/article/:articleID',
                                    name: 'Article',
                                    component: () => import('@/views/guides/Article'),
                                    meta: {
                                        label: 'Article'
                                    }
                                }
                            ]
                        },
                        {
                            path: '/article/:articleID',
                            name: 'Article Guide',
                            component: () => import('@/containers/TheUserGuideContainer'),
                            children: [
                                {
                                    path: '',
                                    name: 'Article',
                                    component: () => import('@/views/guides/Article'),
                                    meta: {
                                        label: 'Article'
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                  path: '/pages',
                  redirect: '/pages/404',
                  name: 'Pages',
                  component: {
                    render(c) {
                        return c('RouterView');
                    }
                  },
                  children: [
                    {
                      path: '404',
                      name: 'Page404',
                      component: () => import('@/views/pages/Page404')
                    }
                  ]
                }
            ]
        },
        {
            path: '*',
            redirect: '/pages/404'
        }
    ]
});

export default router;

const vm = new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>'
});

vm.$mount('#app');
